import axios from "axios";

export const getReadyForDispatch = async () => {
  const response = await axios.get("dispatch/ready");
  return response.data;
};

export const createDispatch = async (data) => {
  const formData = new FormData();
  formData.append("customer_id", data.customer_id || "");
  formData.append("receipt_type", data.receipt_type || "challan");
  formData.append("receipt_number", data.receipt_number || "");
  formData.append("delivery_type", data.delivery_type || "single");
  formData.append("dispatch_date", data.dispatch_date || "");
  formData.append("notes", data.notes || "");
  formData.append("items", JSON.stringify(data.items || []));

  if (data.receiving_image) {
    formData.append("receiving_image", data.receiving_image);
  }

  const response = await axios.post("dispatch", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const addItemsToDispatch = async (id, data) => {
  const response = await axios.post(`dispatch/${id}/items`, {
    items: data.items || [],
    receipt_number: data.receipt_number,
    dispatch_date: data.dispatch_date,
    notes: data.notes,
  });
  return response.data;
};

export const getAllDispatches = async (params = {}) => {
  const response = await axios.get("dispatch", { params });
  return response.data;
};

export const getDispatchById = async (id) => {
  const response = await axios.get(`dispatch/${id}`);
  return response.data;
};
